import { combineReducers, createAction, type UnknownAction } from '@reduxjs/toolkit'
import reduceReducers from 'reduce-reducers'
import { favoritesSlice } from '#store/slices/userData/favoritesSlice'
import { recentManCodesSlice } from '#store/slices/userData/recentManCodesSlice'

const combinedUserDataReducer = combineReducers({
  favorites: favoritesSlice.reducer,
  recentManCodes: recentManCodesSlice.reducer,
})

export const replaceUserData = createAction<ReturnType<typeof combinedUserDataReducer>>('__system/replaceUserData')

const replaceReducer = (state: ReturnType<typeof combinedUserDataReducer>, action: UnknownAction) => {
  if (replaceUserData.match(action)) {
    return action.payload
  }
  return { ...state }
}

export const userDataSlice = reduceReducers(combinedUserDataReducer, replaceReducer)

const combinedActions = {
  ...favoritesSlice.actions,
  ...recentManCodesSlice.actions,
}

const allActionsSet = new Set<string>(Object.values(combinedActions).map((action) => action.type))
allActionsSet.delete(combinedActions.setActiveFavoriteSet.type)

export function isUserDataAction(action: UnknownAction): boolean {
  return allActionsSet.has(action.type)
}

export const {
  _trackManCode,
  removeManCode,
  addFavoriteSet,
  updateFavoriteSet,
  removeFavoriteSet,
  setActiveFavoriteSet,
  addFavorite,
  addFavorites,
  removeFavorite,
  toggleFavorite,
} = combinedActions
export const userDataActions = combinedActions
